import { render, staticRenderFns } from "./QuestionHover.vue?vue&type=template&id=52ef9c95"
import script from "./QuestionHover.vue?vue&type=script&lang=js"
export * from "./QuestionHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports